import { render } from "./RegisterLayout.vue?vue&type=template&id=50c54c36"
import script from "./RegisterLayout.vue?vue&type=script&lang=js"
export * from "./RegisterLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__